import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography, Button, useTheme, Stack } from '@mui/material'

const ResetPasswordSuccess = ({ setView, state }) => {
  const theme = useTheme()
  const { t } = useTranslation('auth')

  const handleResetPasswordSuccess = async (event) => {
    setView('signIn')
  }

  return (
    <Stack
      width="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography
        textAlign="center"
        style={{ color: theme.palette.error.dark }}
        mb={5}
      >
        {t('messagePasswordResetSuccess', state)}
      </Typography>
      <Box mb={5} />
      <Button
        color="primary"
        variant="contained"
        onClick={handleResetPasswordSuccess}
        data-testid="resetPasswordSuccess-button"
      >
        {t('buttons.signUpSuccess')}
      </Button>
    </Stack>
  )
}

export default ResetPasswordSuccess
